export default function changePasswordTemporary(to, from, next) {
    if (to.meta.twoAuthenticationFactor) {
        const twoAuthenticationFactor = localStorage.getItem('two_authentication_factor');
        if (twoAuthenticationFactor == 'true') {
            next('/two-authentication-factor');
        }
    }

    next();
}